export default __webpack_public_path__ + "static/media/Train.916cc0d0.svg";